import React from 'react';
import { Controller } from 'react-hook-form';
import { CLAIM_FORM_TYPES } from '../../../pages/ExpenseClaims/Employee/EmployeeExpenseClaim/constants';
import { DatePicker } from '../../Common';

export default function DateElement({
  formMethods,
  name,
  formType,
  config = {},
}) {
  const {
    control,
    formState: { errors },
  } = formMethods;

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            {...field}
            className={`external-filter-input ${errors?.[name] ? 'is-invalid' : ''}`}
            error={!!errors?.[name]}
            disabled={formType === CLAIM_FORM_TYPES.VIEW}
            placeholder={config?.placeholder || ''}
          />
        )}
      />
      {errors?.[name] && (
        <div className="invalid-feedback d-block">
          {errors?.[name]?.message}
        </div>
      )}
    </>
  );
}
